/** Internal locale keys for UI copy (matches `src/pages/locales/*.json`). */
export const INTERFACE_LANG_KEYS = [
    "english",
    "french",
    "chinese",
    "hindi",
    "spanish",
    "arabic",
    "portuguese",
    "german",
    "japanese",
    "korean",
];

export const DEFAULT_INTERFACE_LANG = "english";

/** Maps short ISO 639-1 codes to our locale keys. */
const LANG_PARAM_MAP = {
    en: "english",
    fr: "french",
    zh: "chinese",
    hi: "hindi",
    es: "spanish",
    ar: "arabic",
    pt: "portuguese",
    de: "german",
    ja: "japanese",
    ko: "korean",
};

/**
 * Normalize URL / snapshot lang to our locale key.
 * Accepts full names (`french`), short codes (`fr`), and BCP 47 tags (`fr-FR`, `zh-Hans`, `ar-SA`).
 * Returns null when unrecognized.
 */
export function normalizeLangParam(value) {
    if (!value || typeof value !== "string") return null;
    const v = value.trim().toLowerCase().replace(/_/g, "-");
    if (INTERFACE_LANG_KEYS.includes(v)) return v;
    if (LANG_PARAM_MAP[v]) return LANG_PARAM_MAP[v];
    const primary = v.split("-")[0];
    if (primary === "zh") return "chinese";
    if (LANG_PARAM_MAP[primary]) return LANG_PARAM_MAP[primary];
    return null;
}

/** Valid interface locale key, or {@link DEFAULT_INTERFACE_LANG}. */
export function resolveInterfaceLang(value) {
    return normalizeLangParam(value) ?? DEFAULT_INTERFACE_LANG;
}

/** App Store / snapshot URL tags for each locale key. */
export const SCREENSHOT_LANG_BCP47 = {
    english: "en-US",
    french: "fr-FR",
    chinese: "zh-Hans",
    hindi: "hi",
    spanish: "es-ES",
    arabic: "ar-SA",
    portuguese: "pt-BR",
    german: "de-DE",
    japanese: "ja",
    korean: "ko",
};

/** Short ISO codes (legacy `?lang=` links). */
export const SCREENSHOT_LANG_ISO = {
    english: "en",
    french: "fr",
    chinese: "zh",
    hindi: "hi",
    spanish: "es",
    arabic: "ar",
    portuguese: "pt",
    german: "de",
    japanese: "ja",
    korean: "ko",
};

export function screenshotLangQueryValue(lang) {
    return SCREENSHOT_LANG_BCP47[lang] ?? SCREENSHOT_LANG_ISO[lang] ?? "en-US";
}
